<template>
  <div class='CardType'>
    <search-form size='medium'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:handle="row">
        <el-link type="primary"
                 @click="()=>changeItem(row.item)">修改</el-link>
        <el-divider direction="vertical"></el-divider>
        <el-link type="danger"
                 @click="removeItem(row.item)">删除</el-link>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import { handleCofirm } from '@/utils'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {
          interst: []
        }, // 返回的数据
        searchForm: [
          { type: 'Input', label: '角色名称：', prop: 'roleName', placeholder: '请输入角色名称' },
          {}
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },
      Table: { // 表格
        primaryBtn: {
          show: true,
          html: '<i class="el-icon-plus"></i>新建',
          handle: () => { this.$router.push('handleRole') }
        },
        handle: true,
        data: [],
        column: [
          { prop: 'id', label: '编号' },
          { prop: 'roleName', label: '名称' },
          { prop: 'updateDate', label: '更新时间' },
          { prop: 'updater', label: '更新人' }
        ]

      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {

  },
  // 方法集合
  methods: {
    // 查询
    searchHandleForm () {
      this.getItemList()
    },
    // 重置
    searchResetForm () {
      this.search.searchData = {}
    },

    removeItem (row) { // 删除行
      handleCofirm('确定要删除该行嘛?', 'type')
        .then(async () => {
          this.deleteRole(row.id)
        })
        .catch(() => { })
    },

    async changeItem (row) { // 修改行
      this.$router.push({ path: 'handleRole', query: { id: row.id } })
    },

    // 删除接口
    deleteRole (id) {
      const params = {
        id
      }
      this.$http.deleteRole(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.getItemList()
          }
        })
    },

    // 列表接口
    getItemList () {
      const { pager, search, Table } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData
      }
      this.$http.getRolePage(params)
        .then((res) => {
          if (res.status === 200) {
            pager.count = res.data.total
            Table.data = res.data.list
          }
        })
    },

    init () {
      this.getItemList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.addfrom {
  padding: 0 60px;
  .el-form-item {
    margin-bottom: 0;
    display: flex;

    ::v-deep .el-form-item__label {
      width: auto !important;
      white-space: nowrap;
    }
  }
  & ::v-deep .el-form-item {
    flex: 1;
    margin-bottom: 0;
    .el-form-item__content {
      flex: 1;
      max-width: 320px;
      min-width: 180px;
      margin-left: 0px !important;
    }
    .el-input,
    .el-select {
      width: 100%;
      max-width: 320px;
      min-width: 180px;
    }
  }
}
</style>
